import { render, staticRenderFns } from "./DeactivateCardForm.vue?vue&type=template&id=006aed54"
import script from "./DeactivateCardForm.vue?vue&type=script&lang=ts"
export * from "./DeactivateCardForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports